import React, { useState } from 'react';
import useOutsideAlerter from 'react-scale/components/audits/SpeedAudit/v2/hooks/useOutsideAlerter';
import CreatableSelect from 'react-select-3/creatable';
import { ValueType, OptionTypeBase } from 'react-select-3/src/types';
import { REVIEW_LEVEL_MAP } from '@scale/shared/types/corp/attemptAudit';

interface CreatableSelectOptionType extends OptionTypeBase {
  value: string;
  label: string;
}

interface ChatBulkAuditReviewLevelPickerProps {
  selectedReviewLevel: string;
  toggleChoose: (reviewLevel: string | null) => void;
  isDisabled?: boolean;
}

const reviewLevelOptions = Object.entries(REVIEW_LEVEL_MAP).map(([key, value]) => ({
  label: key,
  value: value.toString(), // Convert ReviewLevel to string
}));

const findSelectedOption = (value: string): CreatableSelectOptionType | undefined => {
  const option = reviewLevelOptions.find(option => option.value === value);
  return option ? { label: option.label, value: option.value } : undefined;
};

const ChatBulkAuditReviewLevelPicker: React.FC<ChatBulkAuditReviewLevelPickerProps> = ({
  selectedReviewLevel,
  toggleChoose,
  isDisabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = React.useRef<HTMLDivElement | null>(null);
  useOutsideAlerter(wrapperRef, () => setOpen(false));

  const selectedOption = findSelectedOption(selectedReviewLevel);

  const reviewLevelPickerClassname =
    'review-level-picker' + (open ? ' review-level-picker--open' : '');

  return (
    <div className={reviewLevelPickerClassname} ref={wrapperRef}>
      <div className="opts-wrapper">
        <div>
          <CreatableSelect
            fullWidth
            placeholder="Select a review level to send to"
            isMulti={false}
            isDisabled={isDisabled}
            isValidNewOption={() => false}
            options={reviewLevelOptions}
            value={selectedOption || null}
            menuMaxHeight={80}
            onChange={(newValue: ValueType<CreatableSelectOptionType>) => {
              if (!newValue) {
                toggleChoose(null);
              } else {
                toggleChoose((newValue as CreatableSelectOptionType).value);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatBulkAuditReviewLevelPicker;
